import { setupWorker } from 'msw';
import { handlers } from './handlers';
// This configures a Service Worker with the given request handlers.
// Set to run only in test mode
const worker = setupWorker(...handlers);
worker.start();
